import React from 'react'

interface GroupsIconLogoProps {
	width?: number | string
	height?: number | string
	color?: string
	onClick?: () => void
	style?: React.CSSProperties
}

const GroupsIconLogo: React.FC<GroupsIconLogoProps> = ({
	width = 24,
	height = 24,
	color = '#7F7F84',
	onClick,
	style,
}) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width}
		height={height}
		viewBox='0 0 24 24'
		fill='none'
		onClick={onClick}
		style={{ cursor: onClick ? 'pointer' : 'default', ...style }}
	>
		<rect
			x='3'
			y='3'
			width='7'
			height='7'
			rx='2'
			stroke={color}
			strokeWidth='2'
		/>
		<rect
			x='14'
			y='3'
			width='7'
			height='7'
			rx='2'
			stroke={color}
			strokeWidth='2'
		/>
		<rect
			x='14'
			y='14'
			width='7'
			height='7'
			rx='2'
			stroke={color}
			strokeWidth='2'
		/>
		<rect
			x='3'
			y='14'
			width='7'
			height='7'
			rx='2'
			stroke={color}
			strokeWidth='2'
		/>
	</svg>
)

export default GroupsIconLogo
